export default __webpack_public_path__ + "static/media/new_robot_project.acf7e8de.webp";